import React from 'react';
import {useControllerProps, UseControllerPropsResult} from '../../../../../../domain/controllers/ControllerContext';
import {UrlModel} from '../../../../../../domain/models/LineItems/Url.model';
import {TextButton} from '@wix/wix-ui-tpa/cssVars';

export enum ItemLinkDataHooks {
  Anchor = 'ItemLinkDataHooks.Anchor',
  NonClickableItem = 'ItemLinkDataHooks.NonClickableItem',
}

const handleClick = ({
  event,
  navigationStore,
  navigateUrl,
}: {
  event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>;
  navigationStore: UseControllerPropsResult['navigationStore'];
  navigateUrl: string;
}) => {
  event.preventDefault();
  event.stopPropagation();
  return navigationStore.navigateToUrl(navigateUrl);
};

export const ItemLink = ({
  url,
  children,
  tabIndex,
  className,
}: {
  url: UrlModel;
  children: React.ReactChild;
  tabIndex?: number;
  className?: string;
}) => {
  const {navigationStore} = useControllerProps();
  const href = url.fullUrl;

  if (!href) {
    return <div data-hook={ItemLinkDataHooks.NonClickableItem}>{children}</div>;
  }
  const onClickHandler = (event) =>
    handleClick({
      event,
      navigationStore,
      navigateUrl: url.url,
    });

  return (
    <TextButton
      as="a"
      className={className}
      style={{textDecoration: 'none'}}
      href={href}
      onClick={onClickHandler}
      {...(tabIndex !== undefined ? {tabIndex} : {})}
      data-hook={ItemLinkDataHooks.Anchor}>
      {children}
    </TextButton>
  );
};
